/* shipping-progress.js — metro-only, instant when cart:refresh provides subtotal */

(() => {
  const METRO = {
    NSW: [[2000,2234]],
    VIC: [[3000,3207]],
    QLD: [[4000,4207],[4300,4305]],
    SA:  [[5000,5171]],
    WA:  [[6000,6214],[6800,6999]],
    NT:  [[800,829]],
    TAS: [[7000,7019]],
    ACT: [[200,299],[2600,2620],[2900,2920]],
  };

  const THRESH = { NSW:180000, VIC:160000, QLD:330000, SA:270000, WA:400000, NT:430000, TAS:300000, ACT:300000 };

  const inRanges = (n, ranges)=>ranges?.some(([a,b])=>n>=a&&n<=b) || false;
  const stateFor = (z) => {
    if (!Number.isFinite(z)) return null;
    if (z>=200 && z<=299 || z>=2600 && z<=2620 || z>=2900 && z<=2920) return 'ACT';
    if (z>=2000 && z<=2999) return 'NSW';
    if (z>=3000 && z<=3999 || z>=8000 && z<=8999) return 'VIC';
    if (z>=4000 && z<=4999 || z>=9000 && z<=9999) return 'QLD';
    if (z>=5000 && z<=5999) return 'SA';
    if (z>=6000 && z<=6999) return 'WA';
    if (z>=800 && z<=899)   return 'NT';
    if (z>=7000 && z<=7999) return 'TAS';
    return null;
  };
  const isMetro = (st, zip)=>!!(st && inRanges(zip, METRO[st]));
  const clamp = (n,a,b)=>Math.max(a,Math.min(b,n));
  const money = (c)=>new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format((c||0)/100);
  const zipNum = (s)=>{ const n=parseInt(String(s||'').replace(/\D/g,''),10); return Number.isFinite(n)?n:NaN; };

  function updateOne(bar, forcedSubtotal=null) {
    if (!bar) return;
    // AU-only guard
const country  = (bar.dataset.country  || '').toUpperCase();
const currency = (bar.dataset.currency || '').toUpperCase();

if (!country) { bar.hidden = true; return; }            // optional: be conservative
if (country !== 'AU') { bar.hidden = true; return; }
if (currency && currency !== 'AUD') { bar.hidden = true; return; }

// (optional heuristic)
const zraw = bar.dataset.customerZip || '';
if (!country && /[A-Za-z]/.test(zraw)) { bar.hidden = true; return; }
    const z = zipNum(bar.dataset.customerZip);
    const st = stateFor(z);
    if (!isMetro(st, z)) { bar.hidden = true; return; }

    const need = THRESH[st] ?? 0;
    if (!need) { bar.hidden = true; return; }

    const subtotal = Number.isFinite(forcedSubtotal)
      ? forcedSubtotal
      : (parseInt(bar.dataset.subtotalCents||'0',10) || 0);

    const fill   = bar.querySelector('.shipbar__fill, .ct-shipping-fill');
    const msg    = bar.querySelector('.shipbar__message, .ct-shipping-msg');
    const region = bar.querySelector('.shipbar__region');

    const pct = clamp(Math.round((subtotal/need)*100),0,100);
    if (fill)   fill.style.width = pct+'%';
    if (region) region.textContent = `(${st} metro)`;

    if (msg) {
      msg.textContent = subtotal >= need
        ? `You’ve qualified for free shipping`
        : `You’re ${money(need - subtotal)} away from free shipping`;
    }
    bar.hidden = false;
  }

  function updateAll(forcedSubtotal=null) {
    document.querySelectorAll('#shipping-progress').forEach(el=>{
      if (Number.isFinite(forcedSubtotal)) el.dataset.subtotalCents = String(forcedSubtotal);
      updateOne(el, forcedSubtotal);
    });
  }

  // Initial paint
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ()=>updateAll(), { once:true });
  } else { updateAll(); }

  // Theme events
  document.addEventListener('shopify:section:load', ()=>updateAll());

  // Instant path: use subtotal from event.detail if provided
  document.addEventListener('cart:refresh', (e)=>{
    const cents = e?.detail?.subtotalCents;
    updateAll(Number.isFinite(cents) ? cents : null);
  });
})();